import angular from "angular"

import gql from "graphql-tag"

import client from "@/client.js"
import Auth from "@/auth.js"

/**
 * Main service to control the authentication of the user.
 */
const factory = [
  "$rootScope",
  "store",
  "$state",
  "$http",
  "$q",
  "apiService",
  function($rootScope, store, $state, $http, $q, apiService) {
    /**
     * Shows an Auth0 popup to login a user. If the user is correctly
     * logged in, his profile and token returned by Auth0 is stored using
     * localStorage.
     */
    var api_auth_url = apiService.api_auth_url

    $rootScope.$on("unauthenticated", function() {
      console.log("$on:unauthenticated")
      // store.remove('token');
      logout()
    })

    function login(username, password, callback) {
      // Two calls: one the django rest framework auth
      // and the other for the graphql endpoint
      const restLogin = $http({
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        url: apiService.baseUrl + api_auth_url,
        data: JSON.stringify({ username: username, password: password })
      }).then(function(response) {
        var token = response.data.token
        // console.log(jwtHelper.getTokenExpirationDate(token));
        // console.log(jwtHelper.decodeToken(token));
        store.set("user", response.data.user)
        store.set("token", token)
        $http.defaults.headers.common.Authorization = "JWT " + token

        // $state.go('app.estudiantes');
      })
      const graphqlLogin = client
        .mutate({
          mutation: gql`
            mutation TokenAuth($username: String!, $password: String!) {
              tokenAuth(username: $username, password: $password) {
                token
              }
            }
          `,
          variables: {
            username,
            password
          }
        })
        .then(res => {
          // console.log("res", res)
          const token = res.data.tokenAuth.token
          // console.log("token received", token)
          Auth.onLogin(token)
        })

      // Perform both logins on parallel
      $q.all([restLogin, graphqlLogin])
        .then(responses => {
          // When both logins succeed, go to home
          try {
            var role = store.get("user").rol
            switch (role) {
              case "EDITOR ATENCIONES MASIVAS":
                $state.go("app.estudiantes")
                break
              default:
                $state.go("app.home")
                break
            }
          } catch (err) {
            console.log(err)
            $state.go("app.home")
          }
        })
        .catch(responses => {
          console.log("an error...")
          callback()
        })
    }

    /**
     * Removes token and profile information from localStorage and redirects to
     * the home.
     */
    function logout() {
      store.remove("user")
      store.remove("token")
      store.remove("periodo_activo")
      // Remove common header
      $http.defaults.headers.common.Authorization = ""

      // Remote graphql token
      Auth.onLogout()

      // Reset apollo store
      client.resetStore()

      // Go to login
      $state.go("login")
    }

    /**
     * Obtains the token of the user logged in.
     * @return {string} User token.
     */
    function getToken() {
      // console.log("---------------> getting token")
      return store.get("token")
    }

    function getUser() {
      var user = store.get("user")
      if (!user) {
        logout()
        return
      }
      var temp = user.full_name

      return temp.trim() === "" ? user.username : temp
    }

    return {
      login: login,
      logout: logout,
      getToken: getToken,
      getUser: getUser
    }
  }
]

angular.module("appModule").factory("loginService", factory)
